import { StyledBox } from '@webclient/layouts/main/sections/toolbar/components/workspaces-popover/sections/content/styles';
import Tabs from '@webclient/layouts/main/sections/toolbar/components/workspaces-popover/sections/content/tabs';

export default function Content({ children }: React.PropsWithChildren) {
  return <StyledBox>{children}</StyledBox>;
}

Content.Tabs = Tabs;
